import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

@Injectable()
export class AppLoadService {
  public isCompatible: boolean;

  constructor(private platform: Platform) {
    this.isCompatible = this.checkForCompatibility();
  }

  private checkForCompatibility() {
    var isChromium = window['chrome'];
    var winNav = window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof window['opr'] !== 'undefined';
    var isIEedge = this.platform.EDGE;
    var isIOSChrome = winNav.userAgent.match('CriOS');
    var isFirefox = this.platform.FIREFOX;
    var isSafari = this.platform.SAFARI;
    var isBrowser = this.platform.isBrowser;
    if (!isBrowser) {
      return false;
    }
    if (
      isIOSChrome ||
      isFirefox ||
      isOpera ||
      isIEedge ||
      isSafari ||
      (isChromium !== null && typeof isChromium !== 'undefined' && vendorName === 'Google Inc.')
    ) {
      return true;
    }

    return false;
  }
}
